// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyMultiEditWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyMultiEditWebApiHandler_multi } from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  UserPropertyMultiEditRequestWebDto,
  UserPropertyMultiEditResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

export interface RentalManagerUserPropertyMultiEditWebApiHandler_multi_Args {
  postData: UserPropertyMultiEditRequestWebDto;
}

export type RentalManagerUserPropertyMultiEditWebApiHandler_multi_Options = UseMutationOptions<
  UserPropertyMultiEditResponseWebDto,
  unknown,
  RentalManagerUserPropertyMultiEditWebApiHandler_multi_Args
>;

/**
 * Update multiple fields of a listing
 */
export const useRentalManagerUserPropertyMultiEditWebApiHandler_multi = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyMultiEditWebApiHandler_multi_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyMultiEditWebApiHandler_multi_Args) =>
      RentalManagerUserPropertyMultiEditWebApiHandler_multi(args.postData, httpClient),
  });
};
